import React, { useContext, useState, useEffect } from 'react'
import { colors } from '../../../../../Components/consts'
import { Head } from '../../../../../Components/Typography/Text.styles'
import { Desc } from '../../../../../Components/Typography/Text.styles'
import { RosterColumn } from '../styles'
import { AllStarContext } from '../../../../../Context'
import { PlayerDataGQL } from '../../../../../Api'
import { PlayerItem } from './PlayerItem'
import { selectPlayersByRosterType, sortRosterByPosition } from '../../../../../Utils'
import {
  ROSTER_SECTION_CONFIG,
  RosterSection as RosterSectionType,
  ASGTeamIds,
  WLLASGTeamIds,
} from '../../../../../Constant/allStar'
import { isPLLASG } from 'Utils/AllStar/allStarHelper'
import { WLLPlayerItem } from './WLLPlayerItem'

type RosterSectionProps = {
  section: RosterSectionType
  team: ASGTeamIds | WLLASGTeamIds
  league: 'PLL' | 'WLL'
  side: 'left' | 'right'
  showTitle?: boolean
}

export const RosterSection: React.FC<RosterSectionProps> = ({
  section,
  team,
  side,
  showTitle = true,
  league,
}) => {
  const [roster, setRoster] = useState<PlayerDataGQL[]>([])
  const [wllRoster, setWLLRoster] = useState<PlayerDataGQL[]>([])
  const { allStarRosters, wllAllStarRosters, loading } = useContext(AllStarContext)!
  const config = ROSTER_SECTION_CONFIG[section]

  useEffect(() => {
    filterPlayers()
  }, [allStarRosters, wllAllStarRosters, section, team])

  const filterPlayers = () => {
    const teamIndex = team === 'east' || team === 'team izzy' ? 0 : 1
    const players = isPLLASG(team)
      ? allStarRosters?.[teamIndex]?.players
      : wllAllStarRosters?.[teamIndex]?.players

    if (!players || players.length < 1) return

    if (!config.rosterType) {
      if (isPLLASG(team)) {
        const list = sortRosterByPosition(players)
        setWLLRoster(list)
        return
      }
      const list = sortRosterByPosition(players)
      setWLLRoster(list)
      return
    }

    const filteredPlayers = selectPlayersByRosterType(config.rosterType, players)
    const list = sortRosterByPosition(filteredPlayers)
    setRoster(list)
  }

  return (
    <>
      {showTitle && (
        <Head justify="center" textColor={colors.gray.gray20}>
          {config.title}
        </Head>
      )}
      <RosterColumn side={side}>
        {isPLLASG(team) &&
          roster.length > 0 &&
          roster.map((pl) => (
            <PlayerItem
              key={pl.officialId}
              playerInfo={pl}
              showAccolade={isPLLASG(team)}
              league={league}
            />
          ))}
        {!isPLLASG(team) &&
          wllRoster.length > 0 &&
          wllRoster.map((pl) => <WLLPlayerItem key={pl.officialId} playerInfo={pl} />)}
        {!loading && (
          <>
            {isPLLASG(team) && roster.length === 0 && (
              <Desc textColor={colors.gray.gray20}>No {config.title} Available</Desc>
            )}
            {!isPLLASG(team) && wllRoster.length === 0 && (
              <Desc textColor={colors.gray.gray20}>No {config.title} Available</Desc>
            )}
          </>
        )}
      </RosterColumn>
    </>
  )
}
